import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';
import { PAGE_MEDIA_DEFAULTS } from '@/lib/pageMediaCatalog';

// Fetches every PageMedia override record once and exposes a `get(page, slot)`
// helper that falls back to the hardcoded default when no override exists.
export function usePageMedia() {
  const { data = [], isLoading } = useQuery({
    queryKey: ['page-media'],
    queryFn: () => base44.entities.PageMedia.list('-updated_date', 200),
    staleTime: 30 * 1000,
  });

  const map = useMemo(() => {
    const m = {};
    for (const r of data) m[`${r.page_key}.${r.slot_key}`] = r;
    return m;
  }, [data]);

  const get = (page, slot) => map[`${page}.${slot}`]?.image_url || PAGE_MEDIA_DEFAULTS[page]?.[slot] || '';

  return { get, records: data, isLoading };
}